import React, {useEffect, useState} from 'react';
import AppRouter from './routes/AppRouter'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {AppSkeleton} from "./components/layouts/AppSkeleton";
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {TaskFeedbackProvider} from "./providers/TaskFeedbackProvider";
import {AuthProvider} from "./providers/AuthProvider";

const App: React.FC = () => {
    return (
        <AuthProvider>

            <Router>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TaskFeedbackProvider>
                        <AppSkeleton>
                            <AppRouter/>
                        </AppSkeleton>
                    </TaskFeedbackProvider>
                </LocalizationProvider>
            </Router>
        </AuthProvider>
    );
}

export default App;
